import { useMemo } from "react"

import type {
  GridPinnedColumnFields,
  GridValidRowModel,
} from "@mui/x-data-grid-pro"

import type { UseGridPinnedColumnsProps } from "./use-grid-pinned-columns.types"

/**
 * Returns the new pinned columns by taking into account removed columns
 *
 * @returns The new pinned columns
 * @example
 * const pinnedColumns = useGridPinnedColumns({
 *   savedPinnedColumns,
 *   validColumns,
 * })
 */
export const useGridPinnedColumns = <RowT extends GridValidRowModel>({
  savedPinnedColumns,
  validColumns,
}: UseGridPinnedColumnsProps<RowT>): GridPinnedColumnFields => {
  // compute new pinned columns by taking into account removed columns
  const newPinnedColumns: GridPinnedColumnFields = useMemo(() => {
    const filterInvalidColumnKeys = (columnKey: string) => {
      return validColumns.find((validColumn) => validColumn.field === columnKey)
    }

    return {
      left: savedPinnedColumns.left?.filter(filterInvalidColumnKeys),
      right: savedPinnedColumns.right?.filter(filterInvalidColumnKeys),
    }
  }, [savedPinnedColumns, validColumns])

  return newPinnedColumns
}
